import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);
        this.keypads = null;
        this.stateKeys = [this.gettext('battery_low'), this.gettext('tamper_alarm'), this.gettext('missing'),
                        this.gettext('active'), this.gettext('inactive')];
        this.getKeypads();
        this.$element.on('$destroy', () => {
            this.closeModal('GenericStatisticsModal');
        });
    }

    setKeypadName(keypadObj) {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.ModalDialogService.isModalClosed = true;
                    if (keypadObj.name) {
                        this.$scope.currentPromise = this._PanelsService.changePanelKeypad(this.panelId, keypadObj, userCode).then(resp => {
                            this.popMessage(keypadObj.name + ' ' + this.updateOKText);
                            let keypad = resp.data;
                            _.merge(this.keypads, keypad);
                            this.UserCodeService.saveUserCode(userCode);
                        }).finally(this.ModalDialogService.isModalClosed = false)
                    }
                    else {
                        this.$state.reload();
                    }
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

    getKeypads() {

        this.busy = true;

        super.getKeypadsConfigList()
            .then(resp => {
                this.keypads = resp;
                this.busy = false;
            })
            .catch(() => {
                this.busy = false;
            });
    }

    getState(keypad) {

        let stateList = '';
        let openText = null;

        for (let stateOption of this.stateKeys) {

            if(stateOption == 'active' && !keypad[stateOption]){
                stateOption = stateOption.replace('active', 'inactive');
                stateList += this.$filter('humanize')(this.getTranslatableText(stateOption)) + ', ';
            }
            else if (stateOption != 'active' && keypad[stateOption] == true) {

                stateList += this.$filter('humanize')(this.getTranslatableText(stateOption)) + ', ';
            }
        }

        if(openText) {
           stateList = openText + ', ' + stateList;
        }

        return stateList.slice(0, -2);
    }

    loadGenericStatisticsChosenGraph(graphTypeStr, offset = 0) {
        this.showModal('outputGraphModal');
        this._setTimeoutGraphLoading(graphTypeStr, offset, this.getKeypadGenericStatisticsMeasurements);
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/keypads.component/controller.js
 **/